module.exports = __webpack_public_path__ + "assets/img/Main material (20).fa991e68.jpg";